import VueApexCharts from 'vue-apexcharts';

export default {
  components: {
    VueApexCharts,
  },

  data: () => ({
    defaultChartOptions: {
      colors: ['#6995A7', '#C6746B'],
      chart: {
        zoom: { enabled: false },

        toolbar: {
          show: true,
          tools: {
            download: true,
          },
        },
      },
      dataLabels: { enabled: false },

      stroke: {
        width: [4, 2],
        dashArray: [0, 5],
        curve: 'straight',
        lineCap: 'butt',
      },
    },
  }),

  created () {
    this.defaultChartOptions.chart = {
      ...this.defaultChartOptions.chart,
      id: `${this.vector} ${this.chartId} widget chart`,
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/VectorWidgets/widgets/chart.js